/**
 * Performance Caching Layer
 * Handles memory and localStorage persistence.
 */

class CacheStore {
  private memoryCache: Map<string, any> = new Map();

  set(key: string, value: any, persist = false) {
    this.memoryCache.set(key, value);
    if (persist) {
      localStorage.setItem(`nexus_cache_${key}`, JSON.stringify({
        value,
        timestamp: Date.now()
      }));
    }
  }

  get(key: string) {
    // Check memory first (fastest)
    if (this.memoryCache.has(key)) {
      return this.memoryCache.get(key);
    }

    // Check localStorage
    const stored = localStorage.getItem(`nexus_cache_${key}`);
    if (stored) {
      try {
        const { value, timestamp } = JSON.parse(stored);
        // Cache for 5 minutes by default if not specified
        if (Date.now() - timestamp < 300000) {
          this.memoryCache.set(key, value);
          return value;
        }
      } catch (e) {
        localStorage.removeItem(`nexus_cache_${key}`);
      }
    }
    return null;
  }

  clear(key?: string) {
    if (key) {
      this.memoryCache.delete(key);
      localStorage.removeItem(`nexus_cache_${key}`);
    } else {
      this.memoryCache.clear();
    }
  }
}

export const cache = new CacheStore();
